import { loadGdprAdConsentString } from 'owa-gdpr-ad-consent-string';
import { isGdprAdMarket } from 'owa-mail-ads-shared';

export default async function processGetConsentDataCommand(onCallback: any): Promise<void> {
    const gdprAppliesToUser = isGdprAdMarket();

    const consentData = {
        gdprApplies: gdprAppliesToUser,
        hasGlobalScope: true,
        consentData: '',
    };

    if (gdprAppliesToUser) {
        consentData.consentData = await loadGdprAdConsentString();
    }

    onCallback(consentData, true);
    Promise.resolve();
}
